export const isCombinerType = (type) =>
    ['allOf', 'anyOf', 'oneOf'].includes(type);
